import { useMutation } from '@tanstack/react-query';

import { apiMutation } from 'app/utils/request/api';

type InitPassword = {
  email: string;
  role: string;
  password: string;
  token: string;
  redirect: string;
  appUrl: string;
};

const postPath = '/admin/init-password' as const;

export function useInitHotelUserPassword() {
  return useMutation({
    mutationFn: async (payload: InitPassword) =>
      apiMutation(
        'POST',
        {
          path: postPath,
        },
        payload
      ) as Promise<string>,
    onSuccess: (token, payload) => {
      redirectSetUserCookie(token, payload.appUrl, payload.redirect);
    },
  });
}

function redirectSetUserCookie(
  token: string,
  appUrl: string,
  redirect?: string
) {
  const url = `${appUrl}/fr/set-cookie?token=${token}${
    redirect ? `&next=${redirect}` : ''
  }`;

  window.location.href = url;
}
